// Mock data for Win With Meditation clone

export const IMAGES = {
  forest: 'https://images.unsplash.com/photo-1426170042593-200f250dfdaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxmb3Jlc3QlMjBzdW5iZWFtc3xlbnwwfHx8fDE3ODU2MTY4NzZ8MA&ixlib=rb-4.1.0&q=85',
  stars: 'https://images.unsplash.com/photo-1628498188904-036f5e25e93e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxzdGFycnklMjBuaWdodCUyMHNreXxlbnwwfHx8fDE3ODU2MTY4NzZ8MA&ixlib=rb-4.1.0&q=85',
  lake: 'https://images.unsplash.com/photo-1597060330071-69c1ac998254?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxzZXJlbmUlMjBsYWtlJTIwc3VucmlzZXxlbnwwfHx8fDE3ODU2MTY4NzZ8MA&ixlib=rb-4.1.0&q=85',
};

export const meditations = [
  {
    id: 'm1',
    type: 'meditation',
    title: '5- minutes powerful Meditation to Attract Money 💰 || Prosperity Meditation || Attract Wealth-Success',
    shortTitle: 'Prosperity Meditation',
    language: 'English',
    langFlag: '🇺🇸',
    category: 'Mindfulness',
    format: 'Audio',
    duration: 5,
    plays: 1,
    likes: 0,
    rating: 5.0,
    reviews: 0,
    image: IMAGES.forest,
    description: 'Attract Wealth-Success with this powerful meditation and unlock the gateway for abundance and prosperity in life.',
    note: 'Well, this meditation is for everyone who want a strong connection with money and wealth. Also, this meditation opens up the flow of abundance and gratitude in your daily life.',
    featured: true,
    youtubeId: 'inpok4MKVLM',
  },
  {
    id: 'm2',
    type: 'meditation',
    title: 'Deep Sleep Journey & Gentle Starlight Calm',
    shortTitle: 'Deep Sleep Journey',
    language: 'English',
    langFlag: '🇺🇸',
    category: 'Deep Sleep',
    format: 'Audio',
    duration: 6,
    plays: 2890,
    likes: 342,
    rating: 5.0,
    reviews: 12,
    image: IMAGES.stars,
    description: 'Unwind your nervous system and melt into deep, restorative sleep under a canopy of calm starlight.',
    note: 'I created this evening track specifically for nights when your mind refuses to turn off. Turn off bright screens 30 minutes before listening.',
    featured: false,
    youtubeId: 'aXItOY0sLRY',
  },
  {
    id: 'm3',
    type: 'meditation',
    title: '10-Min Stress Relief & Daily Mindful Calm',
    shortTitle: 'Stress Relief',
    language: 'English',
    langFlag: '🇺🇸',
    category: 'Stress & Anxiety',
    format: 'Audio',
    duration: 10,
    plays: 1250,
    likes: 198,
    rating: 5.0,
    reviews: 8,
    image: IMAGES.lake,
    description: 'Release all physical tension and quiet a busy mind with this restorative guided relaxation session.',
    note: 'A gentle guided session designed to dissolve anxiety and restore emotional balance.',
    featured: false,
    youtubeId: 'ZToicYcHIOU',
  },
  {
    id: 'm4',
    type: 'meditation',
    title: 'Focus & Unshakeable Productivity Booster',
    shortTitle: 'Focus Booster',
    language: 'English',
    langFlag: '🇺🇸',
    category: 'Focus & Clarity',
    format: 'Audio',
    duration: 8,
    plays: 940,
    likes: 142,
    rating: 5.0,
    reviews: 5,
    image: IMAGES.forest,
    description: 'Sharpen your focus, eliminate mental fog, and enter a state of calm deep work.',
    note: 'Listen to this 8-minute mental booster before starting work or study sessions for crystal-clear focus.',
    featured: false,
    youtubeId: 'SEfs5TJZ6Nk',
  },
];

export const affirmations = [
  {
    id: 'a1',
    type: 'affirmation',
    title: 'Daily Morning Gratitude & Self-Confidence Affirmations',
    shortTitle: 'Morning Gratitude',
    language: 'English',
    langFlag: '🇺🇸',
    category: 'Morning Energy',
    format: 'Audio',
    duration: 5,
    plays: 420,
    likes: 88,
    rating: 5.0,
    reviews: 3,
    image: IMAGES.lake,
    description: 'Start your day with a series of empowering affirmations designed to build gratitude, confidence, and inner joy.',
    note: 'Repeat these affirmations aloud each morning while looking in the mirror. Feel the meaning behind the words.',
    written: 'I am grateful for this new day. I radiate confidence, calm, and clarity. I am worthy of all the good that flows into my life.',
    featured: true,
    youtubeId: 'QVfvxUgNfaU',
  },
  {
    id: 'a2',
    type: 'affirmation',
    title: 'सकारात्मक ऊर्जा और आत्म-विश्वास (Daily Hindi Affirmations)',
    shortTitle: 'सकारात्मक ऊर्जा',
    language: 'Hindi',
    langFlag: '🇮🇳',
    category: 'Peace & Calm',
    format: 'Audio',
    duration: 6,
    plays: 610,
    likes: 120,
    rating: 5.0,
    reviews: 4,
    image: IMAGES.stars,
    description: 'दैनिक हिंदी सकारात्मक पुष्टियाँ (affirmations) जो आपके भीतर आत्म-विश्वास और शांति जगाती हैं।',
    note: 'हर सुबह इन पुष्टियों को शांति से दोहराएँ। हर शब्द को महसूस करें और उसकी ऊर्जा को अपने भीतर बसने दें।',
    written: 'मैं शांत हूँ। मैं शक्तिशाली हूँ। मैं हर दिन बेहतर होता जा रहा हूँ। ब्रह्मांड मेरे साथ है।',
    featured: false,
    youtubeId: 'YRDaVh1JG2M',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: 'Jessica T.',
    type: 'Personal Story & Gratitude',
    rating: 5,
    message: 'Win With Meditation has become an essential part of my daily mental health routine. The ambient mixer with rain background sound helps me calm my mind before sleeping every night!',
    date: '2026-07-26',
    visible: true,
  },
];

export const moodStates = [
  'All States of Mind',
  'Stressed or Overwhelmed',
  'Exhausted & Seeking Sleep',
  'Restless & Seeking Calm',
  'Distracted & Seeking Focus',
  'Peaceful & Grateful',
];

export const categories = [
  'All Meditations',
  'Mindfulness',
  'Deep Sleep',
  'Stress & Anxiety',
  'Focus & Clarity',
  'Self-Compassion',
];

export const affirmationCategories = [
  'All Affirmations',
  'Morning Energy',
  'Peace & Calm',
  'Gratitude',
  'Self-Love',
];

export const ambientSounds = [
  { id: 'rain', name: 'Gentle Rain' },
  { id: 'ocean', name: 'Ocean Waves' },
  { id: 'forest', name: 'Forest Birds' },
  { id: 'fire', name: 'Crackling Fire' },
  { id: 'wind', name: 'Soft Wind' },
];

export const greetingByHour = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good Morning';
  if (h < 17) return 'Good Afternoon';
  if (h < 21) return 'Good Evening';
  return 'Good Night';
};
